import { render, staticRenderFns } from "./PaymentOrderEcom.vue?vue&type=template&id=9950d6b4"
import script from "./PaymentOrderEcom.vue?vue&type=script&lang=js"
export * from "./PaymentOrderEcom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports